// Libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { getListCategory } from '~/thunks/category/categoryThunk';

export interface ICategoryState {
  isRefreshCategoryList: boolean;
}

export const initialState: ICategoryState = {
  isRefreshCategoryList: false,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setRefreshCategoryList(state: ICategoryState, action: PayloadAction<boolean>) {
      state.isRefreshCategoryList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list category
    builder
      .addCase(getListCategory.pending, (_state) => {})
      .addCase(getListCategory.fulfilled, (_state) => {})
      .addCase(getListCategory.rejected, (_state) => {});
  },
});

// Action
export const categoryActions = categorySlice.actions;

// Selectors
export const selectIsRefreshCategoryList = (state: RootState) => state.category.isRefreshCategoryList;

// Reducer
const categoryReducer = categorySlice.reducer;
export default categoryReducer;
